import * as React from 'react';
import { BarRounded as VisxBarRounded } from '@visx/shape';
import { useTheme, useThemeRawValues } from '@leagueplatform/genesis-core';

export type BarProps = Omit<
  React.ComponentProps<typeof VisxBarRounded>,
  'radius' | 'stroke' | 'strokeDasharray' | 'strokeWidth'
> & {
  highlight?: boolean;
  radius: number;
};

/**
 * Wraps the visx Bar component and applies genesis styles.
 */
export function Bar({ highlight, radius, ...props }: BarProps) {
  const theme = useTheme();
  const rawTheme = useThemeRawValues();

  return (
    <VisxBarRounded
      top // radius top
      radius={radius}
      strokeDasharray="3 3"
      strokeWidth={rawTheme.borderWidths.thick}
      fill={
        theme.colors.dataVizSingleColorBrand ??
        theme.colors.decorativeBrandPrimaryDark
      }
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
